<template>
  <div class="shopCardList">
    <div style="margin: 0;width: 100%;height: 100%">
      <div style="position: relative">
        <div style="background-color: #ffffff; display: flex; position: relative">
          <img :src="row.containerLoadImg" style="width: 100%; height: 100%">
        </div>
      </div>
      <div class="shopCardInfo" style="display: inline-block; background-color: white; width: 100%">
        <div class="goodsFlagShopName" style="width: 40vw">
          {{row.containerLoadName}}
        </div>
        <div style="justify-content: left;margin: 0;color: #9f9f9f;font-size: 2.67vw">
          最小购买量: {{row.miniBuyQty}}
        </div>
        <div class="shopCardMoney" style="margin-bottom: 1.07vw;">
<!--          <div style="">-->
<!--            <span style="font-size: 3.73vw;letter-spacing: -.5vw;">￥</span><span style="font-size: 7.2vw;font-weight: 600">{{$utils.priceFormat(row.price)}}</span>-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <div @click.stop="expend(row)" style="position: absolute;top: 51.5vw;right: 2.9vw;width: 4vw;height: 4vw">
      <van-icon v-show="!row.show" color="#666" style="font-size: 4vw" name="arrow-down" />
      <van-icon v-show="row.show" color="#666" style="font-size: 4vw" name="arrow-up" />
    </div>
<!--    <div style="position: relative">-->
<!--      <div @click.stop @click="changeShop(row)"-->
<!--           v-if="isActive"-->
<!--           style="position: absolute;bottom: 1.07vw;right: 1.87vw;">-->
<!--      </div>-->
<!--      <div class="addButton" @click.stop @click="changeShop(row)"-->
<!--             v-else>-->
<!--          <img :src="icon.addButton" style="width: 3.73vw">-->
<!--      </div>-->
<!--    </div>-->
    <div style="width: 100%;background-color: white">
<!--      分类附属品-->
      <span v-if="row.shopGoodsVOList && row.shopGoodsVOList[0] !== null && row.show" style="font-weight: 700;font-size: 3.9vw;margin-left: 2vw">拼箱商品</span>
      <div v-if="row.shopGoodsVOList && row.shopGoodsVOList[0] !== null && row.show">
        <div v-for="item in row.shopGoodsVOList" :key="item.id" style="width: 100%;height: 9vw;position: relative;margin: 2vw 0 0;">
          <span style="width: 8vw;height: 8vw;display: inline-block;position: absolute;top: 0vw;left: 2px">
            <img v-if="item.goodsImg || item.imgPath" :src="item.goodsImg || item.imgPath" style="width: 100%;height: 100%">
          </span>
          <span style="font-weight: 700;font-size: 3vw;top:0;left: 10vw;position: absolute;width: 28vw;overflow: hidden;display: inline-block;height: 4vw;">{{item.goodsName}}</span>
          <span style="font-weight: 700;font-size: 3vw;position: absolute;left: 10vw;top:4.5vw;position: absolute">￥{{item.price/100}}</span>
          <div style="position: absolute; right: 2.6vw;bottom: 1vw;" class="shopListStepper">
            <van-stepper
              v-model="item.buyQty"
              input-width="6.67vw"
              button-size="3.73vw"
              integer
              :step="item.hsgMiniBuyQty"
              v-if="item.buyQty"
              disable-input
              @plus="changePlusTwo(item, row)"
              @minus="changMinusTwo(item, row)"
              :min="0">
            </van-stepper>
            <div style="position: absolute;bottom: 0vw;right: 0vw;width: 4vw;height: 4vw" v-else @click.stop @click="changePlusTwo(item, row)">
              <img :src="icon.addButton" style="width: 3.73vw">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import addButton from '../../assets/img/icon/addButton.png'
export default {
  name: 'index',
  props: {
    row: Object,
    isActive: Boolean
  },
  data () {
    return {
      icon: {
        addButton
      }
    }
  },
  methods: {
    toInfo (id) {
      this.$emit('toInfo', id)
    },
    changeShop (item) {
      this.$emit('changeShop', item)
    },
    expend (item) {
      this.$emit('expend', item)
    },
    changePlusTwo (item, row) {
      this.$emit('plusTwo', item, row)
    },
    changMinusTwo (item, row) {
      this.$emit('minusTwo', item, row)
    }
  }
}
</script>

<style>
</style>
